// Pure helpers around the condition-field PUT body shape.
//
// `updateField` mutates an existing condition-field row. The PUT request must
// include every field the server cares about — partial bodies wipe values out.
// This builds the full body from a field's current shape so callers only
// override what they're actually changing.

export function buildFieldPutData(fieldsData) {
  if (!fieldsData) return {};
  return {
    id: fieldsData.id,
    value: fieldsData?.rightPart?.value,
    conditionOperatorType: fieldsData?.operator?.type,
    conditionInterval: fieldsData?.rightPart?.conditionInterval,
    leftConditionInterval: fieldsData?.leftPart?.conditionInterval,
    sign: fieldsData?.rightPart?.sign,
    leftSign: fieldsData?.leftPart?.sign,
    leftValue: fieldsData?.leftPart?.value,
    type: fieldsData?.rightPart?.type,
    leftType: fieldsData?.leftPart?.type,
  };
}
